<template>
  <div
    style="background-image:url(images/pageAccueil.jpg); background-size: 100%; "
    >
 
    <div id="title" style="padding:30px;">
      <h1 class="text-white">CANNOPHY</h1>
    </div>
    
    

    <div id="objective" class="card bg-light text-black" style="opacity:80%;">
        <div class="card-body" >
          <p v-html="$t('homePage.description')"></p>
        </div>
      </div>
      <div>
        <b-button to="/InterParcel" variant="light" style="opacity:80%;margin-top:20px;margin-bottom:20px;">
          <h3 style="margin-bottom: 0;">{{$t('homePage.buttonLabel')}}</h3>
        </b-button> 
      </div>
      <div class="card bg-light text-black"  style="opacity:80%;">
        <div class="card-body" >
          <p v-html="$t('homePage.details')"></p>
        </div>
    </div>
  </div>
  
</template>
<script>


export default {
  name: 'WelcomeComponent',

   data() {
      return {
        show: false,
        squarred: '\u00B2'
      }
    },

  async created() {
  },


}
</script>

<style scoped>

.card-body {  
  overflow-y: scroll; 
  width: 100%; 
  text-align: justify; 
  margin-top: 0px;
  font-size: medium;
  font-weight: bold;
}


</style>
